
import React from 'react';
import './HelpCenter.scss';
import { Link } from 'react-router-dom';
import { FaRegEdit } from "react-icons/fa";
import { CiCircleRemove } from "react-icons/ci";


export default function HelpCenter() {
  const boxes = Array.from({ length: 8 }, (_, i) => i + 1);

  return (
    <div className="faq-container p-3">
    <div className="headerr">
   <div className="stock-filters">
    <Link to="/dashboard/HelpCenter"><button className="stock-filter actives">Help</button></Link>
 <Link to="/dashboard/SupportFaqs"><button className="stock-filter ">FAQs</button></Link> 
  <Link to="/dashboard/PrivacyPolicy"><button className="stock-filter ">Privacy</button></Link>
   <Link to="/dashboard/Request"><button className="stock-filter ">Request</button></Link>

   </div>
 
   <div className="search-wrapperr">
     <input
       type="text"
       placeholder="Search by order id"
       className="stock-search"
     />
     <i className="fa-solid fa-magnifying-glass search-icon"></i>
   </div>
 
   <div className="stock-header">
     <div className="stock-actions">
       <Link to="/dashboard/AddNewProductss">
             <button className="stock-btn blue">Edit Helpnote</button>
       </Link>
 <Link to="/dashboard/AddNewservieses">
  <button className="stock-btn">Add New Helpnote</button>
 </Link>
      
     </div>
   </div>
 </div>
      <div className="faq-grid">
        {boxes.map((num) => (
          <div className="faq-box" key={num}>
            <div className="faq-box-top">
              <span>{num}</span>
              <div className="faq-actions">
                <button className="edit">Edit<FaRegEdit/></button>
                <button className="remove">Remove <CiCircleRemove /></button>
              </div>
            </div>
            <input className="faq-question" type="text" placeholder="Question" />
            <textarea className="faq-answer" placeholder="Answer"></textarea>
          </div>
        ))}
      </div>

         <div className="settings-info-actionss container">
          <button type="button" className="cancel">CANCEL</button>
          <button type="submit" className="confirm">CONFIRM</button>
        </div>

    </div>
  );
}
